import React, { useContext } from 'react'
// import React from 'react'
import { Grid } from '@material-ui/core'
import { isEmpty } from 'lodash'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'

import { FactoryFiltersContext } from '../../context/FactoryFiltersContext'

import MainTemplate from '../../templates/MainTemplate'
import Filters from '../../containers/factory/filters/Index'

import OrdersQuantity from '../../containers/factory/widgets/OrdersQuantity'
import TotalItems from '../../containers/factory/widgets/TotalItems'
import TotalRevenue from '../../containers/factory/widgets/TotalRevenue'
import GeneralMonitoringIndustries from '../../containers/factory/dataGrid/GeneralMonitoringIndustries'
import MounthRevenue from '../../containers/factory/charts/MounthRevenue'
import OperatingSystemTransactions from '../../containers/factory/charts/OperatingSystemTransactions'
import TransactionsByBrand from '../../containers/factory/charts/TransactionsByBrand'
import OrderVolume from '../../containers/factory/charts/OrderVolume'
import RevenuePercentage from '../../containers/factory/charts/RevenuePercentage'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: theme.spacing(2)
    }
  })
)

const Index = (): JSX.Element => {
  const { filters } = useContext(FactoryFiltersContext)
  const classes = useStyles()

  return (
    <MainTemplate>
      <div className={classes.container}>
        <Filters />
      </div>
      {
        isEmpty(filters.factory)
          ? <><h3>Selecione um fabricante</h3></>
          : <>
            <Grid item container spacing={1} className={classes.container}>
              <Grid item sm={12} md={4}>
                <OrdersQuantity />
              </Grid>
              <Grid item sm={12} md={4}>
                <TotalRevenue />
              </Grid>
              <Grid item sm={12} md={4}>
                <TotalItems />
              </Grid>
            </Grid>

            <Grid item container spacing={1} className={classes.container}>
              <Grid item xs={12}>
                <GeneralMonitoringIndustries />
              </Grid>
            </Grid>

            <Grid item container spacing={1} className={classes.container}>
              <Grid item xs={12}>
                <MounthRevenue />
              </Grid>
            </Grid>

            <Grid item container spacing={1} className={classes.container}>
              <Grid item lg={6} md={12} xs={12}>
                <OperatingSystemTransactions />
              </Grid>
              <Grid item lg={6} md={12} xs={12}>
                <TransactionsByBrand />
              </Grid>
            </Grid>

            <Grid item container spacing={1} className={classes.container}>
              <Grid item lg={12} md={12} xs={12}>
                <OrderVolume />
              </Grid>
            </Grid>

            <Grid item container spacing={1} className={classes.container}>
              <Grid item xs={12}>
                <RevenuePercentage />
              </Grid>
            </Grid>
          </>
      }
    </MainTemplate>
  )
}

export default Index
